<template>
  <div class="gameList" @click="enterDetails(game)">
    <img v-lazy="game.icon" :key="game.icon" alt />
    <div class="gameInfo">
      <h2 class="gameTitle">{{game.name}}</h2>
    </div>
    <div class="open">
      <button>打开</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["game", "uuid"],
  methods: {
    enterDetails(game) {
      //调用ios的方法
      // var gamejson = {
      //   id:game.id,
      //   name:game.name,
      //   icon:game.icon,
      //   bannerUrl:game.bannerUrl,
      //   gmUrl:game.gameUrl,
      //   isLandscape:game.isLandscape,
      //   gmType:game.gameType,
      //   gmId:game.gameId,
      //   status:game.status
      // };
      if (!this.uuid) return;
      this.$http
        .post(
          `/apiserv/qTLN2Nec/Frontend/myGame/ios/saveMyGame?gameId=${game.id}&uuid=${this.uuid}`
          // 'http://10.244.6.171:3000/qTLN2Nec/Frontend/myGame/ios/saveMyGame?gameId=1&uuid=1111111'
        )
        .then(res => {
          if (res.data.return_code == 200) {
            console.log(res.data.data);
          }
        });
      collect("ios_h5_event_clicktoplay", {
        gameId: game.id,
        uuid: this.uuid
      });
      window.webkit.messageHandlers.enterGMPage.postMessage(game);
    }
  }
};
</script>
<style lang="less" scoped>
.gameList {
  display: flex;
  height: 0.96rem;
  padding: 0.16rem 0.12rem;
  border-bottom: 0.01rem solid #eee;
  > img {
    width: 0.63rem;
    height: 0.63rem;
    border-radius: 0.13rem;
  }
  .gameInfo {
    flex: 3;
    margin-left: 0.13rem;
    display: flex;
    align-items: center;
    h2 {
      line-height: 0.22rem;
      color: #333;
      font-size: 0.16rem;
      font-weight: 500;
      margin-top: 0.03rem;
      margin-bottom: 0.03rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 8em;
    }
  }
  .open {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    > button {
      width: 0.75rem;
      height: 0.29rem;
      background: rgba(255, 80, 1, 0.1);
      border: 0;
      border-radius: 0.15rem;
      color: #ff5000;
      font-weight: 500;
    }
  }
}
</style>  